import type { NavDropdownItem } from "../NavDropdown";

/**
 * Hook that returns the marketing nav items (forWho + features).
 * Shared between LoggedOutHeader and PublicLoggedInHeader to avoid duplication.
 */
export function useMarketingNavItems() {
	const forWhoItems: NavDropdownItem[] = [
		{
			title: "E-commerce Brands",
			description: "Showcase products with video",
			href: "/services/ecommerce",
			icon: <span className="material-symbols-outlined" aria-hidden="true" style={{ fontSize: "20px", color: "#6B3FF2", fontVariationSettings: "'FILL' 1" }}>shopping_bag</span>,
		},
		{
			title: "Agencies",
			description: "Create for multiple clients",
			href: "/services/agencies",
			icon: <span className="material-symbols-outlined" aria-hidden="true" style={{ fontSize: "20px", color: "#6B3FF2", fontVariationSettings: "'FILL' 1" }}>groups</span>,
		},
		{
			title: "Personal Brands",
			description: "Engaging content for influencers",
			href: "/services/coaches",
			icon: <span className="material-symbols-outlined" aria-hidden="true" style={{ fontSize: "20px", color: "#6B3FF2", fontVariationSettings: "'FILL' 1" }}>auto_awesome</span>,
		},
		{
			title: "Small Businesses",
			description: "Communicate your values",
			href: "/services/brand-videos",
			icon: <span className="material-symbols-outlined" aria-hidden="true" style={{ fontSize: "20px", color: "#6B3FF2", fontVariationSettings: "'FILL' 1" }}>ads_click</span>,
		},
		{
			title: "Enterprises",
			description: "Scalable video solutions",
			href: "/services/saas",
			icon: <span className="material-symbols-outlined" aria-hidden="true" style={{ fontSize: "20px", color: "#6B3FF2", fontVariationSettings: "'FILL' 1" }}>corporate_fare</span>,
		},
	];

	const featuresItems: NavDropdownItem[] = [
		{
			title: "Video Creation",
			description: "Generate videos from text",
			href: "/features/ai-video",
			icon: <span className="material-symbols-outlined" aria-hidden="true" style={{ fontSize: "20px", color: "#6B3FF2", fontVariationSettings: "'FILL' 1" }}>video_camera_front</span>,
		},
		{
			title: "Brand Voice",
			description: "Custom voice integration",
			href: "/features/brand-voice",
			icon: <span className="material-symbols-outlined" aria-hidden="true" style={{ fontSize: "20px", color: "#6B3FF2", fontVariationSettings: "'FILL' 1" }}>mic</span>,
		},
		{
			title: "Templates",
			description: "Ready-to-use video templates",
			href: "/features/templates",
			icon: <span className="material-symbols-outlined" aria-hidden="true" style={{ fontSize: "20px", color: "#6B3FF2", fontVariationSettings: "'FILL' 1" }}>dashboard_customize</span>,
		},
		{
			title: "Quick Export",
			description: "Export in multiple formats",
			href: "/features/export",
			icon: <span className="material-symbols-outlined" aria-hidden="true" style={{ fontSize: "20px", color: "#6B3FF2", fontVariationSettings: "'FILL' 1" }}>download</span>,
		},
	];

	return { forWhoItems, featuresItems };
}
